import React from 'react';

export const AiSparkleIcon = () => (
    <svg 
        xmlns="http://www.w3.org/2000/svg" 
        viewBox="0 0 16 16" 
        focusable="false"
        style={{ width: '16px', height: '16px' }}
    >
        <path 
            d="M15 1.875c-1.678 0-1.875-.197-1.875-1.875h-.938c0 1.678-.196 1.875-1.874 
            1.875v.938c1.678 0 1.874.196 1.874 1.874h.938c0-1.678.197-1.875 1.875-1.875v-.937z"
            fill="currentColor"
        />
        <path 
            fillRule="evenodd"
            d="M6.563 15H7.5a6.57 6.57 0 016.563-6.563V7.5A6.57 6.57 0 017.5.937h-.938A6.57 
            6.57 0 010 7.5v.938A6.57 6.57 0 016.563 15zm.468-2.616A7.547 7.547 0 002.616 7.97 7.547 7.547 
            0 007.03 3.553a7.547 7.547 0 004.416 4.416 7.547 7.547 0 00-4.416 4.415z"
            clipRule="evenodd"
            fill="currentColor"
        />
    </svg>
); 